<template>
    <div class="modal fade" id="createTaskModal" role="dialog" aria-labelledby="createTaskModallLabel" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="createTaskModalLabel">{{$t('coordinations.pageTitle')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <div class="row">
                            <div class="col-md-6 form-group">
                                <label class="font-weight-bold">{{$t('coordinations.title')}}</label>
                                <div>{{model.title}}</div>
                            </div>
                            <div class="col-md-12 form-group">
                                <label class="font-weight-bold">{{$t('request_n')}}</label>
                                <div>{{model.request}}</div>
                            </div>
                            <div class="col-md-12 form-group" v-if="model.itemLink">
                                <label class="font-weight-bold">{{$t('coordinations.requestLink')}}</label>
                                <div><a :href="model.itemLink" @click="onClose">{{$t('link')}}</a></div>
                            </div>
                            <div class="col-md-12 form-group" v-if="model.attachments && model.attachments.length">
                                <div class="font-weight-bold">{{$t('coordinations.attachments')}}</div>
                                <div>
                                    <div lass="mb-2" v-for="item in model.attachments" :key="_uid+item.fileName">
                                        <file-crud :file="item"
                                                   :readonly="true"
                                                   :showDescription="false"
                                                   :type="item.docTypeCode">
                                        </file-crud>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 form-group">
                                <div class="font-weight-bold required">{{$t('coordinations.comment')}}</div>
                                <div class="mb-3">
                                    <textarea v-model="comment" class="form-control"></textarea>
                                    <div v-if="showValidation" class="text-danger">{{$t('validation.requiredField')}}</div>
                                </div>
                                <div class="text-info radio-message mb-2">
                                    <i class="fa fa-exclamation-circle"></i>
                                    {{$t('coordinations.commentMessage')}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <vs-button color="success" type="filled" @click="onAcceptClick" :disabled="showValidation">{{$t('coordinations.accept')}}</vs-button>
                    <vs-button color="danger" type="filled" @click="onRejectClick" :disabled="showValidation">{{$t('coordinations.reject')}}</vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import coordinationsService from '@/services/coordinations.service';
    import { Coordination } from '@/models/models';
    import moment from 'moment';
    import FileCrud from '../common/FileCRUD';

    export default {
        components: {
            FileCrud,
        },
        props: {
            value: {},
            show: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                model: new Coordination(),
                moment: moment,
                isLoading: false,
                comment: '',
                commentValidation: true
            };
        },
        methods: {
            onAcceptClick() {
                this.sendAnswer(true);
            },
            onRejectClick() {
                this.sendAnswer(false);
            },
            sendAnswer(isApproved) {
                if (this.comment) {
                    this.commentValidation = false;
                    this.isLoading = true;

                    coordinationsService
                        .answer({
                            coordinationId: this.model.id,
                            isApproved,
                            comment: this.comment
                        })
                        .then(data => {
                            this.$vs.notify({
                                color: 'success',
                                title: this.$t('updateSuccess'),
                                text: ''
                            });
                            this.$emit('updated', this.model);
                            this.hide();
                        })
                        .catch(err =>
                            this.$vs.notify({
                                color: 'danger',
                                title: this.$t('notifications.error'),
                                text: this.$helpers.errorText(err)
                            })
                        );
                } else {
                    this.commentValidation = true;
                }
            },
            hide() {
                this.comment = null;
                $(this.$el).modal('hide');
            },
            onClose() {
                this.$emit('update:show', false);
                this.$emit('onClose');
            }
        },
        computed: {
            showValidation() {
                return !this.comment;
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new Coordination({ ...this.value });
                    this.comment = null;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                    this.comment = null;
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .radio-message {
        padding: 3px 3px 3px 5px;
        border-left: 3px solid #03a9f4;
        box-shadow: 1px 1px 1px 1px lightgrey;
    }

    div.radio label {
        color: inherit;
        cursor: pointer;
    }

    .bmd-form-group {
        padding-top: 1rem !important;
    }
</style>
